import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Select } from '@driftt/tide-selects'
import { Section, H4, P, Div } from '@driftt/tide-core'
import { tracking } from '@driftt/traffic-control'

import { changeView } from 'modules/filter_builder/actions'

const mapDispatchToProps = dispatch => {
  return {
    onChangeView: view => {
      dispatch(changeView(view))
    }
  }
}

const Attributes = ({ innerProps, data }) => {
  return (
    <Section className="filter-builder--property-select-option" {...innerProps} onClick={() => innerProps.onClick(data.value)}>
      <H4>{data.text.title}</H4>
      <P type="subtle">{data.text.desc}</P>
    </Section>
  )
}

const options = [
  {
    label: 'properties', 
    value: 'Properties',
    text: {
      title: 'Attribute',
      desc: 'Properties about a contact attached both automatically and manually such as name, email, etc.'
    }
  },
  {
    label: 'pbselection',
    value: 'PBSelection',
    text: {
      title: 'Playbook events',
      desc: 'Events a contact has completed (or not) within your playbooks'
    }
  },
  {
    label: 'tags',
    value: 'Tags',
    text: {
      title: 'Tags',
      desc: 'Tags that exist, or don\'t exist, on your contacts'
    }
  },
  {
    label: 'events',
    value: 'Events',
    text: {
      title: 'Raw events',
      desc: 'Things a contact has done (or not done) within Drift, such as booked a meeting, clicked a CTA, etc.'
    }
  }
]

const SelectedVal = (selected) => {
  const {data} = selected

  return (
    <Div className="filter-builder-dropdown--selected">
      {data.text.title}
    </Div>
  )
}

class PropertySelection extends Component {
  changeValue = ({label, value}) => {
    tracking.trackEvent(`Contact Filter Builder - ${value} Selected`)
    const { onChangeView } = this.props

    onChangeView(value)
  }
  render() {
    const { previousScreen } = this.props

    return (
      <Div className="contact-segment-builder-contact-types-container">
        <Div className="contact-segment-builder-contact-types">
          <Select
            defaultValue={previousScreen ? options.filter(opt => opt.value === previousScreen) : null}
            components={{Option: Attributes, SingleValue: SelectedVal}} 
            options={options}
            closeMenuOnSelect={true}
            isClearable={false}
            label="Filter by"
            onChange={this.changeValue}
            placeholder="Select a filter"
            backspaceRemovesValue={false}
          />
        </Div>
      </Div>
    )
  }
}

export default connect(null, mapDispatchToProps)(PropertySelection)
